import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Button as WOTButton, Tooltip } from 'react-wot-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import { enterClan, formatCooldownError } from 'state/actions/recommended_clans'
import {
    JOIN_CLAN_BUTTON_TITLE,
    SEND_APPLY_BUTTON_TITLE,
    LANDING_CLANS_APPLIED,
    LANDING_CLANS_WAITING,
    TOOLTIP_BY_ERROR_CODE,
} from '../../../../constants'
import { RecommendedClanPropTypes } from '../../../../../../propTypes'

import styles from './EnterClan.scss'

export const EnterClan = ({ onClickButton, clan }) => {
    const [isButtonClicked, setIsButtonClicked] = useState(false)
    const { inviteId, isClanAcceptableForAutoJoining, id } = clan
    const dispatch = useDispatch()
    const { loading, errors, applied, cooldownTill } = useSelector((state) => state.recommendedClans.joinResult)
    const cooldownError = Object.values(errors).includes(43)

    let tooltipError = TOOLTIP_BY_ERROR_CODE[errors[id]]
    if (cooldownError) {
        tooltipError = formatCooldownError(cooldownTill)
    }

    const isDisabled = loading || tooltipError !== undefined || cooldownError
    const isApplied = applied.includes(id)

    useEffect(() => {
        if (isButtonClicked && !loading) {
            setIsButtonClicked(false)
        }
    }, [isButtonClicked, loading])

    const handleButtonClick = () => {
        if (isDisabled) {
            return
        }

        dispatch(enterClan(clan))
        setIsButtonClicked(true)
        onClickButton()
    }

    return (
        <div className={styles.base}>
            {isApplied ? (
                <span className={styles.applied}>{LANDING_CLANS_APPLIED}</span>
            ) : (
                <WOTButton
                    type={'primary'}
                    isDisabled={isDisabled && !isButtonClicked}
                    onClick={handleButtonClick}
                    tooltipId={`button-card-tooltip-${id}`}
                >
                    <span className={classnames(styles.button, loading && isButtonClicked && styles.isLoading)}>
                        {inviteId !== null || isClanAcceptableForAutoJoining ?
                            JOIN_CLAN_BUTTON_TITLE :
                            SEND_APPLY_BUTTON_TITLE}
                    </span>
                </WOTButton>
            )}
            {isDisabled && <Tooltip id={`button-card-tooltip-${id}`}>{tooltipError || LANDING_CLANS_WAITING}</Tooltip>}
        </div>
    )
}

EnterClan.propTypes = {
    onClickButton: PropTypes.func,
    clan: RecommendedClanPropTypes,
}

export default EnterClan



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Card/components/EnterClan/EnterClan.jsx